export const VERSION_HEADER_KEY = 'x-request-webappversion';
